import { render, staticRenderFns } from "./activitySeriesCertificatesList.vue?vue&type=template&id=08f3cfee&scoped=true&"
import script from "./activitySeriesCertificatesList.vue?vue&type=script&lang=js&"
export * from "./activitySeriesCertificatesList.vue?vue&type=script&lang=js&"
import style0 from "./activitySeriesCertificatesList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./activitySeriesCertificatesList.vue?vue&type=style&index=1&lang=css&"
import style2 from "./activitySeriesCertificatesList.vue?vue&type=style&index=2&id=08f3cfee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f3cfee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\tavo\\source\\repos\\GEG\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('08f3cfee', component.options)
    } else {
      api.reload('08f3cfee', component.options)
    }
    module.hot.accept("./activitySeriesCertificatesList.vue?vue&type=template&id=08f3cfee&scoped=true&", function () {
      api.rerender('08f3cfee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src\\views\\certificates\\activitySeriesCertificatesList.vue"
export default component.exports